document.addEventListener("DOMContentLoaded", function() {
  // Initialize the carousel
  const carousels = document.querySelectorAll('.announcement-bar-main-carousel');
  
  if (carousels) {
    carousels.forEach(carousel => {
      var flkty = new Flickity(carousel, {
        cellAlign: 'center',
        wrapAround: true,
        pageDots: false,
        prevNextButtons: false,
        autoPlay: 3000,
        contain: true,
        adaptiveHeight: true,
        on: {
          ready: function() {
            setTimeout(function() {
              var hiddenCells = carousel.querySelectorAll('.carousel-cell:nth-child(n+2)');
              hiddenCells.forEach(cell => {
                cell.style.removeProperty("display");
              });
              flkty.reloadCells(); // Recalculate layout after cells are shown
            }, 100); // Delay to ensure proper layout
          }
        }
      });
    })
  }
})

if (window.innerWidth > 767 ) {
document.addEventListener("DOMContentLoaded", function() {
  const menuItems = document.querySelectorAll('.custom-megamenu-item');
  const submenuItems = document.querySelectorAll('.sub-custom-megamenu-item');

  menuItems.forEach((menuItem) => {
    menuItem.addEventListener('mouseover', function() {
      menuItem.classList.add('active');
      const datatrigger = menuItem.getAttribute('data-trigger');

      submenuItems.forEach((submenuItem) => {
        const datatarget = submenuItem.getAttribute('data-target');
        if(datatrigger == datatarget ){
          submenuItem.style.display = "block";
          submenuItem.classList.add("active");
        }else{
          submenuItem.style.display = "none";
          submenuItem.classList.remove("active");
        }
      });
    });
  });

  document.addEventListener('mouseover', function(event) {
    const isMenuHovered = Array.from(menuItems).some(menuItem => menuItem.contains(event.target));
    const isSubmenuHovered = Array.from(submenuItems).some(submenuItem => submenuItem.contains(event.target));

    if (!isMenuHovered && !isSubmenuHovered) {
      submenuItems.forEach((submenuItem) => {
        submenuItem.style.display = "none";
        submenuItem.classList.remove("active");
      });
    }
  });
});
}else{
  document.addEventListener("DOMContentLoaded", function() {
    const menuItems = document.querySelectorAll('.custom-megamenu-item');
    const submenuItems = document.querySelectorAll('.sub-custom-megamenu-item');
  
    function handleClick(event) {
  
      menuItems.forEach(item => item.classList.remove('active')); // Remove 'active' class from all menu items
  
      const menuItem = event.currentTarget;
      menuItem.classList.add('active');
      const datatrigger = menuItem.getAttribute('data-trigger');
  
      submenuItems.forEach((submenuItem) => {
        const datatarget = submenuItem.getAttribute('data-target');
        if (datatrigger == datatarget) {
          event.preventDefault();
          event.stopPropagation(); // Stop propagation of the click event
          submenuItem.style.display = "block";
          submenuItem.classList.add("active");
        } else {
          submenuItem.style.display = "none";
          submenuItem.classList.remove("active");
        }
      });
    }
  
    menuItems.forEach((menuItem) => {
      menuItem.addEventListener('click', handleClick);
    });
  
    document.addEventListener('click', function(event) {
      const isMenuHovered = Array.from(menuItems).some(menuItem => menuItem.contains(event.target));
      const isSubmenuHovered = Array.from(submenuItems).some(submenuItem => submenuItem.contains(event.target));
  
      if (!isMenuHovered && !isSubmenuHovered) {
        submenuItems.forEach((submenuItem) => {
          submenuItem.style.display = "none";
          submenuItem.classList.remove("active");
        });
      }
    });
  });
}



window.addEventListener('load', function(){
  function MatchHeight() {
    $('.product-card-wrap-custom').matchHeight({});
    $('.product-price-wrap-custom').matchHeight({});
  }

  MatchHeight();
});

/**
 * Artisti cart-drawer customizations — extends CartDrawer from app.js
 */
(function () {
  if (!customElements.get('cart-drawer')) return;

  const proto = customElements.get('cart-drawer').prototype;

  proto.removeProductEvent = function () {
    this.querySelectorAll('.remove').forEach((remove) => {
      if (!remove.dataset.listenerAdded) {
        remove.addEventListener('click', (event) => {
          event.preventDefault();
          this.updateQuantity(event.currentTarget.dataset.index, '0');
        });
        remove.dataset.listenerAdded = 'true';
      }
    });

    this.subscriptionEvent();
    this.unsubscribeEvent();
    this.selectEvent();
    this.addEvent();
    this.checkoutEvent();
    this.setupCarousel();
  };

  proto.subscriptionEvent = function () {
    this.querySelectorAll('.subscribe-button').forEach((subscription) => {
      if (!subscription.dataset.listenerAdded) {
        subscription.addEventListener('click', (event) => {
          event.preventDefault();
          this.subscribe(
            event.target.dataset.index,
            event.target.dataset.quantity,
            event.target.dataset.sellingPlan
          );
        });
        subscription.dataset.listenerAdded = 'true';
      }
    });
  };

  proto.unsubscribeEvent = function () {
    this.querySelectorAll('.unsubscribe-button').forEach((unsubscribe) => {
      if (!unsubscribe.dataset.listenerAdded) {
        unsubscribe.addEventListener('click', (event) => {
          event.preventDefault();
          this.unsubscribe(event.target.dataset.index, event.target.dataset.quantity);
        });
        unsubscribe.dataset.listenerAdded = 'true';
      }
    });
  };

  proto.selectEvent = function () {
    this.querySelectorAll('.subscription-select').forEach((selector) => {
      if (!selector.dataset.listenerAdded) {
        selector.addEventListener('change', (event) => {
          event.preventDefault();
          this.subscribe(event.target.dataset.index, event.target.dataset.quantity, event.target.value);
        });
        selector.dataset.listenerAdded = 'true';
      }
    });
  };

  proto.addEvent = function () {
    this.querySelectorAll('.cart-item-add').forEach((button) => {
      if (!button.dataset.listenerAdded) {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          this.addItem(event.target.dataset.variant, event.target);
        });
        button.dataset.listenerAdded = 'true';
      }
    });
  };

  proto.checkoutEvent = function () {
    const form = this.querySelector('.cart-drawer-buttons form');
    if (!form) return;

    if (!form.dataset.listenerAdded) {
      form.addEventListener('submit', (event) => {
        event.preventDefault();

        const button = form.querySelector('.checkout-button');
        button.classList.add('loading');

        let offers = Number(sessionStorage.getItem('offers') ?? 0);
        let lastOffer = sessionStorage.getItem('last_offer');

        if (lastOffer) {
          lastOffer = new Date(lastOffer);
        } else {
          lastOffer = new Date();
          lastOffer.setDate(lastOffer.getDate() - 1);
          lastOffer.setHours(0, 1, 0, 0);
        }

        const todayStart = new Date();
        todayStart.setHours(0, 0, 0, 0);

        if (lastOffer < todayStart) {
          offers = 0;
        }

        offers++;
        sessionStorage.setItem('offers', offers);
        sessionStorage.setItem('last_offer', new Date().toISOString());

        if (offers <= 3) {
          fetch('/cart?view=product-offer', { method: 'GET' })
            .then((response) => response.text())
            .then((text) => {
              const offerContent = new DOMParser()
                .parseFromString(text, 'text/html')
                .querySelector('#Product-Offer-Content');
              button.classList.remove('loading');

              if (offerContent && offerContent.innerHTML) {
                //this.showOfferPopup(offerContent.innerHTML);
                this.resumeCheckout();
              } else {
                this.resumeCheckout();
              }
            })
            .catch((err) => {
              console.error('Offer fetch failed, continuing to checkout', err);
              this.resumeCheckout();
            });
        } else {
          this.resumeCheckout();
        }
      });
      form.dataset.listenerAdded = 'true';
    }
  };

  proto.resumeCheckout = function () {
    window.location.href = '/checkout';
  };

  proto.showOfferPopup = function (htmlContent) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('offer-popup-wrapper');

    const overlay = document.createElement('div');
    overlay.style.cssText = `
      position: absolute;
      inset: 0;
      background: rgba(196, 196, 196, 0.7);
      backdrop-filter: blur(3px);
    `;
    wrapper.appendChild(overlay);

    const popup = document.createElement('div');
    popup.classList.add('offer-popup');
    popup.innerHTML = htmlContent;

    wrapper.appendChild(popup);
    document.body.appendChild(wrapper);

    overlay.addEventListener('click', () => {
      cleanup();
      this.resumeCheckout();
    });

    const closeBtn = popup.querySelector('.popup-offer-close');
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        cleanup();
        this.resumeCheckout();
      });
    }

    const checkoutBtn = popup.querySelector('.checkout-button');
    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', (event) => {
        event.preventDefault();
        cleanup();
        this.resumeCheckout();
      });
    }

    const variantSelector = popup.querySelector('.offer-product-select');
    const variantImage = popup.querySelector('.offer-product-image img');
    const variantAdd = popup.querySelector('.cart-item-add');
    const variantPrice = popup.querySelector('.price');

    if (variantSelector) {
      const org_srcset = variantImage ? variantImage.dataset.srcset : '';

      window.addEventListener('load', () => {
        const loadedImages = new Set();

        [...variantSelector.options].forEach((option) => {
          const srcset = option.dataset.srcset;

          if (srcset && !loadedImages.has(srcset)) {
            loadedImages.add(srcset);

            const image = new Image();
            image.srcset = srcset;
            lazySizes.loader.unveil(image);
          }
        });
      });

      variantSelector.addEventListener('change', (event) => {
        const selectedOption = event.target.selectedOptions[0];

        if (!selectedOption) return;

        if (variantImage) {
          if (selectedOption.dataset.srcset) {
            variantImage.setAttribute('srcset', selectedOption.dataset.srcset);
          } else {
            variantImage.setAttribute('srcset', org_srcset);
          }
        }
        if (variantAdd && selectedOption.value) {
          variantAdd.dataset.variant = selectedOption.value;
          const url = new URL(variantAdd.href, window.location.origin);
          url.searchParams.set('id', selectedOption.value);
          variantAdd.href = url.toString();
        }
        if (variantPrice && (selectedOption.dataset.price || selectedOption.dataset.rrp)) {
          const option_price = selectedOption.dataset.price ? selectedOption.dataset.price / 100 : null;
          const option_rrp = selectedOption.dataset.rrp ? selectedOption.dataset.rrp / 100 : null;

          if (option_price && option_rrp && option_rrp > option_price) {
            const savedAmount = Math.round(((option_rrp - option_price) / option_rrp) * 100);

            variantPrice.innerHTML = `
              <del><span class="amount">${option_rrp.toLocaleString(undefined, { style: 'currency', currency: 'AUD', currencyDisplay: 'narrowSymbol' })}</span></del>
              <ins><span class="amount discounted">${option_price.toLocaleString(undefined, { style: 'currency', currency: 'AUD', currencyDisplay: 'narrowSymbol' })}</span></ins>
              <span class="badges"><span class="badge onsale">Save ${savedAmount}%</span></span>
            `;
          } else {
            variantPrice.innerHTML = `
              <ins><span class="amount discounted">${option_price.toLocaleString(undefined, { style: 'currency', currency: 'AUD', currencyDisplay: 'narrowSymbol' })}</span></ins>
            `;
          }
        }
      });
    }

    if (variantAdd) {
      variantAdd.addEventListener('click', (event) => {
        event.preventDefault();

        if (event.target.closest('.offer-product-image')) {
          event.target.closest('.offer-product-image').classList.add('loading');
        }
        const body = JSON.stringify({
          id: event.target.dataset.variant,
          quantity: 1,
          properties: { '_source': 'artisti', '_attribution': 'pre-purchase' },
          sections_url: window.location.pathname
        });
        fetch(`${theme.routes.cart_add_url}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body
        })
          .then((response) => response.text())
          .then(() => {
            cleanup();
            this.resumeCheckout();
          });
      });
    }

    requestAnimationFrame(() => {
      wrapper.classList.add('visible');

      const chat = document.getElementById('ShopifyChat');
      if (chat) {
        chat.style.zIndex = 90000;
      }
    });

    let timerId;
    const timerMinutes = popup.querySelector('.offer-timer-minutes');
    const timerSeconds = popup.querySelector('.offer-timer-seconds');
    const endTime = Date.now() + 3 * 60 * 1000;

    const updateTimer = () => {
      const remaining = Math.max(0, endTime - Date.now());
      const mins = String(Math.floor(remaining / 60000));
      const secs = String(Math.floor((remaining % 60000) / 1000)).padStart(2, '0');
      if (timerMinutes) timerMinutes.textContent = `${mins}`;
      if (timerSeconds) timerSeconds.textContent = `${secs}`;

      if (remaining <= 0) {
        cleanup();
        this.resumeCheckout();
      }
    };

    timerId = setInterval(updateTimer, 400);
    updateTimer();

    function cleanup() {
      clearInterval(timerId);

      wrapper.classList.add('loading');

      setTimeout(() => {
        wrapper.remove();
      }, 200);
    }
  };

  proto.setupCarousel = function () {
    const carousel = this.querySelector('.product-recommendations-drawer__products');
    if (!carousel || carousel.dataset.carouselBound) return;

    const items = carousel.children;
    if (!items.length) return;

    carousel.dataset.carouselBound = 'true';

    const btnLeft = this.querySelector('.carousel-button.left');
    const btnRight = this.querySelector('.carousel-button.right');
    let itemWidth = items[0].offsetWidth + 16;

    const updateButtons = () => {
      if (btnLeft) btnLeft.disabled = carousel.scrollLeft <= 0;
      if (btnRight) btnRight.disabled = carousel.scrollLeft >= carousel.scrollWidth - carousel.clientWidth;
    };

    const scrollCarousel = (direction) => {
      carousel.scrollBy({ left: direction * itemWidth, behavior: 'smooth' });
      setTimeout(updateButtons, 300);
    };

    if (btnLeft) btnLeft.addEventListener('click', () => scrollCarousel(-1));
    if (btnRight) btnRight.addEventListener('click', () => scrollCarousel(1));

    let isDown = false;
    let startX;
    let scrollLeftValue;

    carousel.addEventListener('mousedown', (e) => {
      isDown = true;
      startX = e.pageX - carousel.offsetLeft;
      scrollLeftValue = carousel.scrollLeft;
    });
    carousel.addEventListener('mouseleave', () => {
      isDown = false;
    });
    carousel.addEventListener('mouseup', () => {
      isDown = false;
    });
    carousel.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - carousel.offsetLeft;
      carousel.scrollLeft = scrollLeftValue + (startX - x);
    });

    carousel.addEventListener('touchstart', (e) => {
      startX = e.touches[0].pageX;
    });
    carousel.addEventListener('touchmove', (e) => {
      const x = e.touches[0].pageX;
      carousel.scrollLeft += startX - x;
      startX = x;
    });

    carousel.addEventListener('scroll', () => {
      clearTimeout(carousel.snapTimeout);
      carousel.snapTimeout = setTimeout(() => {
        const nearestIndex = Math.round(carousel.scrollLeft / itemWidth);
        carousel.scrollTo({ left: nearestIndex * itemWidth, behavior: 'smooth' });
        updateButtons();
      }, 100);
    });

    updateButtons();
  };

  proto.subscribe = function (line, quantity, selling_plan) {
    this.querySelector(`#CartDrawerItem-${line}`).classList.add('thb-loading');
    const body = JSON.stringify({
      line,
      quantity,
      selling_plan,
      properties: { '_source': 'artisti', '_attribution': 'switch to subscription' },
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
    dispatchCustomEvent('line-item:change:start', { selling_plan });
    fetch(`${theme.routes.cart_change_url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body
    })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        this.removeProductEvent();

        dispatchCustomEvent('line-item:change:end', {
          selling_plan,
          cart: parsedState
        });
        const item = this.querySelector(`#CartDrawerItem-${line}`);
        if (item) item.classList.remove('thb-loading');
      });
  };

  proto.unsubscribe = function (line, quantity) {
    this.querySelector(`#CartDrawerItem-${line}`).classList.add('thb-loading');
    const selling_plan = null;
    const body = JSON.stringify({
      line,
      quantity,
      selling_plan,
      properties: { '_source': 'artisti', '_attribution': 'switch to one-time' },
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
    dispatchCustomEvent('line-item:change:start', { selling_plan });
    fetch(`${theme.routes.cart_change_url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body
    })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        this.removeProductEvent();

        dispatchCustomEvent('line-item:change:end', {
          selling_plan,
          cart: parsedState
        });
        const item = this.querySelector(`#CartDrawerItem-${line}`);
        if (item) item.classList.remove('thb-loading');
      });
  };

  proto.addItem = function (variant, button) {
    button.closest('.product-cart-item').classList.add('thb-loading');
    const body = JSON.stringify({
      id: variant,
      quantity: 1,
      properties: { '_source': 'artisti', '_attribution': 'cart product recommendations' },
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
    dispatchCustomEvent('line-item:add:start', { item: variant });
    fetch(`${theme.routes.cart_add_url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body
    })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        this.removeProductEvent();

        dispatchCustomEvent('line-item:add:end', {
          item: variant,
          cart: parsedState
        });
        const cartItem = button.closest('.product-cart-item');
        if (cartItem) cartItem.classList.remove('thb-loading');
      });
  };

  const originalConnectedCallback = proto.connectedCallback;
  proto.connectedCallback = function () {
    originalConnectedCallback.call(this);
    this.removeProductEvent();
    if (!this._artistiPageShowBound) {
      this._onPageShow = () => this.refresh();
      window.addEventListener('pageshow', this._onPageShow);
      this._artistiPageShowBound = true;
    }
  };

  const originalDisconnectedCallback = proto.disconnectedCallback;
  proto.disconnectedCallback = function () {
    if (this._onPageShow) {
      window.removeEventListener('pageshow', this._onPageShow);
      this._artistiPageShowBound = false;
    }
    originalDisconnectedCallback.call(this);
  };

  const originalOpen = proto.open;
  proto.open = function () {
    originalOpen.call(this);
    this.removeProductEvent();
  };

  const originalOnChange = proto.onChange;
  proto.onChange = function (event) {
    originalOnChange.call(this, event);
    this.removeProductEvent();
  };

  proto.updateQuantity = function (line, quantity) {
    const lineItem = this.querySelector(`#CartDrawerItem-${line}`);
    if (lineItem) lineItem.classList.add('thb-loading');

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
    dispatchCustomEvent('line-item:change:start', { quantity });
    fetch(`${theme.routes.cart_change_url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body
    })
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector
          );
        });

        this.removeProductEvent();

        dispatchCustomEvent('line-item:change:end', {
          quantity,
          cart: parsedState
        });
        const item = this.querySelector(`#CartDrawerItem-${line}`);
        if (item) item.classList.remove('thb-loading');
      });
  };

  const originalRefresh = proto.refresh;
  proto.refresh = function () {
    originalRefresh.call(this);
    this.removeProductEvent();
  };

  const drawer = document.querySelector('cart-drawer');
  if (drawer) {
    drawer.removeProductEvent();
    if (!drawer._artistiPageShowBound) {
      drawer._onPageShow = () => drawer.refresh();
      window.addEventListener('pageshow', drawer._onPageShow);
      drawer._artistiPageShowBound = true;
    }
  }
})();

(function labelEmbeddedNewsletterForms() {
  const labelControls = () => {
    document.querySelectorAll('.klaviyo-form input, .klaviyo-form select, .klaviyo-form textarea').forEach((control) => {
      const type = (control.getAttribute('type') || '').toLowerCase();
      if (type === 'hidden' || type === 'submit' || type === 'button' || type === 'reset') return;
      if (control.getAttribute('aria-label') || control.getAttribute('aria-labelledby')) return;
      if (control.id && document.querySelector('label[for="' + CSS.escape(control.id) + '"]')) return;
      const accessibleName = control.getAttribute('placeholder') || 'Email';
      control.setAttribute('aria-label', accessibleName);
    });
  };

  const start = () => {
    labelControls();
    const observer = new MutationObserver(labelControls);
    document.querySelectorAll('.klaviyo-form, [class*="klaviyo-form-"]').forEach((form) => {
      observer.observe(form, { childList: true, subtree: true });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
